// extracted by mini-css-extract-plugin
export default {"column__truncated":"codes-table-row_column__truncated__fnBL+"};